import { render, staticRenderFns } from "./LocaleButton.vue?vue&type=template&id=1e2c1724&"
import script from "./LocaleButton.vue?vue&type=script&lang=js&"
export * from "./LocaleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports